import { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// import emailjs from "emailjs-com";
import { Link } from "react-router-dom";

const HomeHero = () => {
  const [activeTab, setActiveTab] = useState("consultation");

  // Separate captcha states and refs
  const [captchaConsultation, setCaptchaConsultation] = useState(false);
  const [captchaHire, setCaptchaHire] = useState(false);
  const recaptchaConsultationRef = useRef();
  const recaptchaHireRef = useRef();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    businessName: "",
    businessEmail: "",
    hireService: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaConsultation = (token) => {
    const verified = !!token;
    setCaptchaConsultation(verified);

    // ✅ Clear the error if user just verified captcha
    if (verified && message.text === "Please verify you are human.") {
      setMessage({ type: "", text: "" });
    }
  };

  const handleCaptchaHire = (token) => {
    const verified = !!token;
    setCaptchaHire(verified);

    // ✅ Clear the error if user just verified captcha
    if (verified && message.text === "Please verify you are human.") {
      setMessage({ type: "", text: "" });
    }
  };

  const resetCaptchaConsultation = () => {
    recaptchaConsultationRef?.current?.reset();
    setCaptchaConsultation(false);
  };

  const resetCaptchaHire = () => {
    recaptchaHireRef?.current?.reset();
    setCaptchaHire(false);
  };

  // Free Consultation
  const handleFreeConsultation = async (e) => {
    e.preventDefault();

    if (!captchaConsultation) {
      setMessage({ type: "error", text: "Please verify you are human." });
      return;
    }

    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.service.trim()
    ) {
      setMessage({
        type: "error",
        text: "Please fill out all required fields.",
      });
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(
        "https://tissa-api.tissatech.in/consultation_sendmail.php",
        {
          method: "POST",
          body: new URLSearchParams({
            name: formData.name,
            email: formData.email,
            services: formData.service,
            hire_consultant: "false",
          }),
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      const result = await response.json();

      if (response.ok) {
        setMessage({ type: "success", text: "Request sent successfully!" });
        setFormData({ ...formData, name: "", email: "", service: "" });
        resetCaptchaConsultation();
      } else {
        setMessage({
          type: "error",
          text: result?.message || "Failed to send.",
        });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    }

    setSubmitting(false);
    setTimeout(() => setMessage({ type: "", text: "" }), 3000);
  };

  // Hire Consultant
  const handleHireConsultant = async (e) => {
    e.preventDefault();

    if (!captchaHire) {
      setMessage({ type: "error", text: "Please verify you are human." });
      return;
    }

    if (
      !formData.businessName.trim() ||
      !formData.businessEmail.trim() ||
      !formData.hireService.trim()
    ) {
      setMessage({
        type: "error",
        text: "Please fill out all required fields.",
      });
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(
        "https://tissa-api.tissatech.in/consultation_sendmail.php",
        {
          method: "POST",
          body: new URLSearchParams({
            name: formData.businessName,
            email: formData.businessEmail,
            services: formData.hireService,
            hire_consultant: "true",
          }),
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      const result = await response.json();

      if (response.ok) {
        setMessage({ type: "success", text: "Request sent successfully!" });
        setFormData({
          ...formData,
          businessName: "",
          businessEmail: "",
          hireService: "",
        });
        resetCaptchaHire();
      } else {
        setMessage({
          type: "error",
          text: result?.message || "Failed to send.",
        });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    }

    setSubmitting(false);
    setTimeout(() => setMessage({ type: "", text: "" }), 3000);
  };

  return (
    <section className="bg-blue-900 pt-32 pb-20 relative">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row">
          {/* Hero Content */}
          <div className="lg:w-7/12">
            <div className="text-white pt-16 pb-32 lg:pb-20 lg:pr-12">
              <span className="block text-lg font-medium mb-4">
                EMPOWER YOUR BUSINESS
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
                Excellent IT services for your success
              </h1>
              <div className="mt-8">
                <Link
                  to="/contact-us"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded inline-block transition-colors"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>

          {/* Hero Form */}
          <div className="lg:w-5/12 mt-10 lg:mt-0">
            <div className="bg-white rounded-lg shadow-xl p-6 mb-8">
              {/* Tabs */}
              <div className="flex mb-6 border-b">
                <button
                  className={`flex-1 pb-3 text-center font-medium ${
                    activeTab === "consultation"
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                  onClick={() => {
                    setActiveTab("consultation");
                    setFormData({
                      ...formData,
                      name: "",
                      email: "",
                      service: "",
                    });
                    resetCaptchaConsultation();
                    setMessage({ type: "", text: "" });
                  }}
                >
                  Free Consultation
                </button>
                <button
                  className={`flex-1 pb-3 text-center font-medium ${
                    activeTab === "hire"
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                  onClick={() => {
                    setActiveTab("hire");
                    setFormData({
                      ...formData,
                      hireService: "",
                      businessName: "",
                      businessEmail: "",
                    });
                    resetCaptchaHire();
                    setMessage({ type: "", text: "" });
                  }}
                >
                  Hire Consultants
                </button>
              </div>

              {/* Consultation Form */}
              {activeTab === "consultation" && (
                <div>
                  <div className="mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                      Free Consultation
                    </h2>
                    <p className="text-gray-600">
                      Get Free Consultation For IT Solutions
                    </p>
                  </div>
                  <form onSubmit={handleFreeConsultation}>
                    <div className="mb-4">
                      <label
                        htmlFor="name"
                        className="block text-gray-700 mb-2"
                      >
                        Your Full Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Full Name"
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block text-gray-700 mb-2"
                      >
                        Email Address <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div className="mb-6">
                      <label
                        htmlFor="service"
                        className="block text-gray-700 mb-2"
                      >
                        Services <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="" disabled>
                          Select Service
                        </option>
                        <option value="Custom Software Development">
                          Custom Software Development
                        </option>
                        <option value="Mobile Application Development">
                          Mobile Application Development
                        </option>
                        <option value="API Development">API Development</option>
                        <option value="Integration">Integration</option>
                        <option value="Data Analytics">Data Analytics</option>
                        <option value="Big Data">Big Data</option>
                        <option value="AI, ML & GEN AI">AI, ML & GEN AI</option>
                        <option value="SAP Services">SAP Services</option>
                        <option value="Odoo Services">Odoo Services</option>
                        <option value="Consulting">Consulting</option>
                      </select>
                    </div>

                    <div className="my-4 mb-5">
                      <ReCAPTCHA
                        ref={recaptchaConsultationRef}
                        sitekey="6LeNuOMrAAAAAEy9XUUXRP9K2D7xH7hOxAeycx5H"
                        onChange={handleCaptchaConsultation}
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded font-medium transition-colors flex justify-center"
                      disabled={submitting}
                    >
                      {submitting ? (
                        <div className="flex items-center">
                          <svg
                            className="animate-spin h-5 w-5 mr-3"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              fill="none"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing...
                        </div>
                      ) : (
                        "Get Free Consultation"
                      )}
                    </button>

                    {message.text && (
                      <div
                        className={`mt-4 ${
                          message.type === "success"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {message.text}
                      </div>
                    )}
                  </form>
                </div>
              )}

              {/* Hire Consultants Form */}
              {activeTab === "hire" && (
                <div>
                  <div className="mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                      Hire Consultants
                    </h2>
                    <p className="text-gray-600">
                      Hire Consultant For Your Business Need
                    </p>
                  </div>

                  <form onSubmit={handleHireConsultant}>
                    <div className="mb-4">
                      <label
                        htmlFor="businessName"
                        className="block text-gray-700 mb-2"
                      >
                        Business Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="businessName"
                        name="businessName"
                        value={formData.businessName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Business Name"
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="businessEmail"
                        className="block text-gray-700 mb-2"
                      >
                        Email Address <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="businessEmail"
                        name="businessEmail"
                        value={formData.businessEmail}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div className="mb-6">
                      <label
                        htmlFor="hireService"
                        className="block text-gray-700 mb-2"
                      >
                        For which service you want to hire?{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="hireService"
                        name="hireService"
                        value={formData.hireService}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="" disabled>
                          Select Service
                        </option>
                        <option value="Custom Software Development">
                          Custom Software Development
                        </option>
                        <option value="Mobile Application Development">
                          Mobile Application Development
                        </option>
                        <option value="API Development">API Development</option>
                        <option value="Integration">Integration</option>
                        <option value="Data Analytics">Data Analytics</option>
                        <option value="Big Data">Big Data</option>
                        <option value="AI, ML & GEN AI">AI, ML & GEN AI</option>
                        <option value="SAP Services">SAP Services</option>
                        <option value="Odoo Services">Odoo Services</option>
                        <option value="Consulting">Consulting</option>
                      </select>
                    </div>

                    <div className="my-4 mb-5">
                      <ReCAPTCHA
                        ref={recaptchaHireRef}
                        sitekey="6LeNuOMrAAAAAEy9XUUXRP9K2D7xH7hOxAeycx5H"
                        onChange={handleCaptchaHire}
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded font-medium transition-colors flex justify-center"
                      disabled={submitting}
                    >
                      {submitting ? (
                        <div className="flex items-center">
                          <svg
                            className="animate-spin h-5 w-5 mr-3"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              fill="none"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing...
                        </div>
                      ) : (
                        "Hire Consultant"
                      )}{" "}
                    </button>

                    {message.text && (
                      <div
                        className={`mt-4 ${
                          message.type === "success"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {message.text}
                      </div>
                    )}
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute left-0 bottom-0 w-1/3 h-1/2 bg-blue-800 rounded-tr-full opacity-30"></div>
    </section>
  );
};

export default HomeHero;
